export default __webpack_public_path__ + "static/Effra_Bd-cd35f1bfaf7ab5ce145a95b073277deb.ttf";